module.exports = __webpack_public_path__ + "static/media/customer.e65a6536.svg";